module.exports = __webpack_public_path__ + "media/images/icons/users-double-53c2361668f5df6cbe603524b0102818.svg";